module.exports = __webpack_public_path__ + "img/g17.b159c6ce.jpg";